import "./animation";

import "./_afarkas_lazyload";
import "./extension";
